import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

const btmLegacy = (state = {}) => {
  // if(Object.keys(action.brandsThatMatterPage).length < 1) {
  //   return false;
  // }
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  // const wpTitle = get(action, 'brandsThatMatterPage.title.rendered');
  // const img = get(
  //   action,
  //   'brandsThatMatterPage._embedded.wp:featuredmedia[0].source_url'
  // );
  // const wpExcerpt = get(action, 'brandsThatMatterPage.excerpt.rendered');
  // const socialTitle = wpTitle ? striptags(wpTitle).trim() : ''; // displays for twitter and social platforms
  // const seoTitle = get(action, 'brandsThatMatterPage.acf.title'); // displays on google and browser tab
  // const description = wpExcerpt ? striptags(wpExcerpt).trim() : '';
  // const url = `https://www.fastcompany.com/brands-that-matter/2021`;
  // const wpTitle = ' 144 Brands That Matter in 2022';
  const img =
    'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/10/BTM_Digitalv1_social-share_crop.jpg';
  // const wpExcerpt =
  //   'Fast Company’s 2022 Brands That Matter list recognizes companies leading on social action, sustainability, inclusivity, and fun';
  const socialTitle = 'Brands That Matter 2022';
  const seoTitle = 'Brands That Matter in 2022';
  const url = `https://www.fastcompany.com/brands-that-matter/list`;
  const description =
    'Fast Company’s 2022 Brands That Matter list recognizes companies leading on social action, sustainability, inclusivity, and fun';

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle,
    url,
    description,
    image: img,
    articleSection: 'Brands That Matter',
    config: get(state, 'config'),
    facebookTitleOverride: `${socialTitle} | Fast Company`,
    twitterTitleOverride: `${socialTitle} | Fast Company`
  });
};

const btmList = (state = {}, action = {}) => {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const wpTitle = get(action, 'brandsThatMatterListPage.wpData.title.rendered');
  const img = get(
    action,
    'brandsThatMatterListPage.wpData._embedded.wp:featuredmedia[0].source_url'
  );
  const wpExcerpt = get(
    action,
    'brandsThatMatterListPage.wpData.excerpt.rendered'
  );
  const socialTitle = wpTitle ? striptags(wpTitle).trim() : ''; // displays for twitter and social platforms
  const seoTitle = get(action, 'brandsThatMatterListPage.wpData.acf.title'); // displays on google and browser tab
  const description = wpExcerpt ? striptags(wpExcerpt).trim() : '';
  const url = `https://www.fastcompany.com/brands-that-matter/list`;
  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle,
    url,
    description,
    image: img,
    articleSection: 'Brands That Matter',
    config: get(state, 'config'),
    facebookTitleOverride: `${socialTitle} | Fast Company`,
    twitterTitleOverride: `${socialTitle} | Fast Company`
  });
};

export { btmLegacy, btmList };
